// Espace cliente Elirati (section elirati-space) : connexion par code e-mail, commande en cours et suivi,
// historique, codes promo, avis (avec photos réduites à 1600 px), numéro WhatsApp, aide.
// API : dashboard.elirati.com/api/espace, jeton Bearer en localStorage (el_space_token), aucun cookie.
// ?mock=1 (ou late, delivered, prepared, address, empty, nopromo, séparés par des virgules) : données fictives, aucun appel réseau.

const COPY = {
  en: {
    hello: 'Hello, {name}', helloPlain: 'Hello', spaceEyebrow: 'Your Elirati space', logout: 'Log out',
    nav: { home: 'Overview', orders: 'My orders', codes: 'My codes', reviews: 'Leave a review', account: 'My account', help: 'Help & contact' },
    navShort: { home: 'Overview', orders: 'Orders', codes: 'Codes', reviews: 'Reviews', account: 'Account', help: 'Help' },
    navLabel: 'My space',
    stages: { placed: 'Placed', prepared: 'Being prepared', shipped: 'Shipped', out: 'Out for delivery', delivered: 'Delivered', cancelled: 'Cancelled' },
    titles: {
      placed: 'Your order is confirmed', prepared: 'Your order is being prepared', shipped: 'Your parcel is on its way',
      out: 'Your parcel is out for delivery', delivered: 'Your parcel has been delivered', cancelled: 'This order was cancelled'
    },
    progress: 'Order progress',
    etaLabel: 'Expected delivery',
    late: 'Your parcel is taking longer than planned; we’re on it.', lateLink: 'Write to us on WhatsApp',
    cancelledNote: 'If you have a question about this order, write to us.',
    currentOrder: 'Your current order', lastOrder: 'Your last order', orderName: 'Order {name}', placedOn: 'Placed on {date}',
    trackingLabel: 'Elirati tracking number', follow: 'Follow my parcel', copy: 'Copy', copied: 'Copied', copiedLive: '{text} copied',
    latest: 'Latest update', noTracking: 'Your tracking number will appear here as soon as your parcel leaves.',
    seeOrder: 'Order details', items: 'Your pieces', address: 'Delivery address', total: 'Total', qty: 'Qty {n}',
    reorder: 'Order again', reviewIt: 'Leave a review',
    addressChange: 'To change it, write to us on WhatsApp, ideally before your parcel ships.',
    returnTitle: 'Returns', returnText: 'You have 14 days after delivery to return a piece. Read the policy, or write to us on WhatsApp and we will guide you.',
    returnPolicy: 'Returns policy', whatsappUs: 'WhatsApp us',
    addrTitle: 'Add your Saudi short address', addrText: 'Couriers in Saudi Arabia need your short address (4 letters + 4 digits, e.g. RRRD2929) to deliver your parcel.',
    addrCta: 'Add my short address',
    noOrders: 'No orders yet', noOrdersText: 'Your orders and their tracking will appear here.', shop: 'Discover the collection',
    ordersTitle: 'My orders', ordersLead: 'Every order, its pieces and its tracking.',
    inProgress: 'In progress', pastOrders: 'Past orders', otherOrders: 'Your other orders', allOrders: 'All my orders',
    codesTitle: 'My codes', codesLead: 'Your private codes, ready to use.', promoKicker: 'Your private code', promoPct: '−{percent}%',
    promoText: 'Tap “Use it” and the code is applied at checkout.', useIt: 'Use it',
    noCode: 'No code for you right now. We’ll show it here as soon as there is one.',
    teaserCode: 'A private code for you', teaserCodeText: '{percent}% off with {code}.', seeCodes: 'See my codes',
    teaserReview: 'How do you find your pieces?', teaserReviewText: 'A few words and a photo help other women choose.',
    reviewsTitle: 'Leave a review', reviewsLead: 'Tell us how you find your pieces. Your review is published after a quick check.',
    noReviewable: 'Once an order is delivered, you can review its pieces here.', reviewed: 'Reviewed', reviewThis: 'Review',
    fromOrder: 'Order {name}',
    rating: 'Your rating', starN: '{n} out of 5', rTitle: 'Title (optional)', rBody: 'Your review', rName: 'First name shown',
    rPhotos: 'Photos (up to 3)', addPhoto: 'Add a photo', removePhoto: 'Remove photo', rSubmit: 'Send my review', sending: 'Sending…',
    thanksTitle: 'Thank you', thanksText: 'Your review is with us. It will appear on the site after a quick check.',
    eRating: 'Choose a rating from 1 to 5 stars.', eBody: 'Write a few words (10 characters at least).', eName: 'Add the first name to show.',
    ePhotos: 'One photo could not be added. Try a JPG or PNG.', eDuplicate: 'You have already reviewed this piece. Thank you!',
    eRate: 'Too many attempts. Please try again in a few minutes.', eServer: 'Something went wrong. Please try again.',
    eNetwork: 'No connection. Check your internet and try again.',
    rvEyebrow: 'Your opinion', rvTitle: 'How is your Amira?', rvLead: 'Hello {name}. Tell us about your order {order}: a few words, and a photo if you like.',
    rvLeadPlain: 'Tell us about your order {order}: a few words, and a photo if you like.', chooseItem: 'Which piece?',
    rvExpired: 'This review link has expired or is no longer valid.', goSpace: 'Go to my Elirati space', rvAllDone: 'You have reviewed every piece of this order. Thank you!',
    nextItem: 'Review another piece',
    accountTitle: 'My account', accountLead: 'Your details for orders and delivery.', emailLabel: 'Email',
    phoneLabel: 'WhatsApp number', phoneHint: 'For delivery updates and the courier’s call.', save: 'Save', saved: 'Saved.',
    ePhone: 'Enter a valid number with the country code, e.g. +971 50 123 4567.',
    helpTitle: 'Help & contact', helpLead: 'Write to us, we reply quickly.', whatsapp: 'WhatsApp', whatsappText: 'The fastest way to reach us',
    mailText: 'We answer every email', shipping: 'Shipping policy', returns: 'Returns policy', contactPage: 'Contact page', trackPage: 'Track a parcel',
    faqTitle: 'Questions',
    faq: [
      ['How long does delivery take?', '5 to 7 days after your order. The expected dates are on your order, here in your space.'],
      ['Can I return a piece?', 'Yes, within 14 days of delivery. Write to us on WhatsApp and we will guide you.'],
      ['How do I follow my parcel?', 'Your tracking number appears in “My orders” as soon as your parcel leaves. Tap “Follow my parcel”.'],
      ['Can I change my delivery address?', 'Write to us on WhatsApp as soon as possible, ideally before your parcel ships.']
    ],
    loadError: 'We couldn’t load your space. Check your connection and try again.', retry: 'Try again',
    sessionEnded: 'Your session has ended. Enter your email to log in again.',
    eEmail: 'Enter a valid email address.', eCode: 'Enter the 6 digits of your code.', eMismatch: 'This code is not right. Check it and try again.',
    eExpired: 'This code has expired. Ask for a new one below.', eRateLogin: 'Too many attempts. Wait a few minutes, then try again.',
    resendIn: 'Resend the code in {s} s', resend: 'Resend the code', resent: 'A new code is on its way.'
  },
  ar: {
    hello: 'أهلاً {name}', helloPlain: 'أهلاً بكِ', spaceEyebrow: 'مساحتكِ في إليراتي', logout: 'تسجيل الخروج',
    nav: { home: 'نظرة عامة', orders: 'طلباتي', codes: 'أكوادي', reviews: 'اكتبي تقييمكِ', account: 'حسابي', help: 'المساعدة والتواصل' },
    navShort: { home: 'الرئيسية', orders: 'طلباتي', codes: 'أكوادي', reviews: 'التقييم', account: 'حسابي', help: 'المساعدة' },
    navLabel: 'مساحتي',
    stages: { placed: 'تم الطلب', prepared: 'قيد التجهيز', shipped: 'تم الشحن', out: 'مع المندوب', delivered: 'تم التوصيل', cancelled: 'ملغى' },
    titles: {
      placed: 'تم تأكيد طلبكِ', prepared: 'طلبكِ قيد التجهيز', shipped: 'طردكِ في الطريق',
      out: 'طردكِ مع المندوب', delivered: 'تم توصيل طردكِ', cancelled: 'تم إلغاء هذا الطلب'
    },
    progress: 'مراحل الطلب',
    etaLabel: 'التوصيل المتوقع',
    late: 'طردكِ يأخذ وقتاً أطول من المتوقع، ونحن نتابعه.', lateLink: 'راسلينا على واتساب',
    cancelledNote: 'إذا عندكِ أي سؤال عن هذا الطلب، راسلينا.',
    currentOrder: 'طلبكِ الحالي', lastOrder: 'آخر طلب لكِ', orderName: 'الطلب {name}', placedOn: 'بتاريخ {date}',
    trackingLabel: 'رقم التتبع من إليراتي', follow: 'تتبّعي طردي', copy: 'نسخ', copied: 'تم النسخ', copiedLive: 'تم نسخ {text}',
    latest: 'آخر تحديث', noTracking: 'سيظهر رقم التتبع هنا أول ما ينشحن طردكِ.',
    seeOrder: 'تفاصيل الطلب', items: 'قطعكِ', address: 'عنوان التوصيل', total: 'المجموع', qty: 'الكمية {n}',
    reorder: 'اطلبيها مرة ثانية', reviewIt: 'اكتبي تقييمكِ',
    addressChange: 'لتغييره، راسلينا على واتساب، ويُفضّل قبل شحن طردكِ.',
    returnTitle: 'الإرجاع', returnText: 'عندكِ 14 يوماً بعد التوصيل لإرجاع أي قطعة. اطّلعي على السياسة، أو راسلينا على واتساب ونرشدكِ.',
    returnPolicy: 'سياسة الإرجاع', whatsappUs: 'راسلينا على واتساب',
    addrTitle: 'أضيفي عنوانكِ الوطني المختصر', addrText: 'شركات التوصيل في السعودية تحتاج عنوانكِ الوطني المختصر (4 حروف و4 أرقام، مثل RRRD2929) لتوصيل طردكِ.',
    addrCta: 'أضيفي العنوان المختصر',
    noOrders: 'ما عندكِ طلبات بعد', noOrdersText: 'ستظهر طلباتكِ وتتبّعها هنا.', shop: 'اكتشفي المجموعة',
    ordersTitle: 'طلباتي', ordersLead: 'كل طلباتكِ، قطعها وتتبّعها.',
    inProgress: 'قيد التنفيذ', pastOrders: 'طلبات سابقة', otherOrders: 'طلباتكِ الأخرى', allOrders: 'كل طلباتي',
    codesTitle: 'أكوادي', codesLead: 'أكوادكِ الخاصة، جاهزة للاستخدام.', promoKicker: 'كودكِ الخاص', promoPct: '−{percent}%',
    promoText: 'اضغطي «استخدميه» ويُطبَّق الكود عند الدفع.', useIt: 'استخدميه',
    noCode: 'ما عندكِ كود حالياً. سيظهر هنا أول ما يتوفر.',
    teaserCode: 'كود خاص لكِ', teaserCodeText: 'خصم {percent}% مع الكود {code}.', seeCodes: 'أكوادي',
    teaserReview: 'ما رأيكِ في قطعكِ؟', teaserReviewText: 'كلمات قليلة وصورة تساعد غيركِ على الاختيار.',
    reviewsTitle: 'اكتبي تقييمكِ', reviewsLead: 'أخبرينا عن رأيكِ في قطعكِ. يُنشر تقييمكِ بعد مراجعة سريعة.',
    noReviewable: 'بعد توصيل طلبكِ، تقدرين تقيّمين قطعه هنا.', reviewed: 'تم التقييم', reviewThis: 'قيّمي',
    fromOrder: 'الطلب {name}',
    rating: 'تقييمكِ', starN: '{n} من 5', rTitle: 'العنوان (اختياري)', rBody: 'رأيكِ', rName: 'الاسم الظاهر',
    rPhotos: 'صور (حتى 3)', addPhoto: 'أضيفي صورة', removePhoto: 'احذفي الصورة', rSubmit: 'أرسلي تقييمي', sending: 'جارٍ الإرسال…',
    thanksTitle: 'شكراً لكِ', thanksText: 'وصلنا تقييمكِ، وسيظهر على الموقع بعد مراجعة سريعة.',
    eRating: 'اختاري تقييماً من 1 إلى 5 نجوم.', eBody: 'اكتبي بضع كلمات (10 أحرف على الأقل).', eName: 'أضيفي الاسم الذي سيظهر.',
    ePhotos: 'تعذّرت إضافة إحدى الصور. استخدمي صور JPG أو PNG.', eDuplicate: 'قيّمتِ هذه القطعة من قبل. شكراً لكِ!',
    eRate: 'محاولات كثيرة. حاولي مرة ثانية بعد بضع دقائق.', eServer: 'حدث خطأ. حاولي مرة ثانية.',
    eNetwork: 'لا يوجد اتصال. تحققي من الإنترنت وحاولي مرة ثانية.',
    rvEyebrow: 'رأيكِ', rvTitle: 'ما رأيكِ في أميرا؟', rvLead: 'أهلاً {name}. أخبرينا عن طلبكِ {order}: كلمات قليلة، ومع صورة إن أحببتِ.',
    rvLeadPlain: 'أخبرينا عن طلبكِ {order}: كلمات قليلة، ومع صورة إن أحببتِ.', chooseItem: 'أي قطعة؟',
    rvExpired: 'رابط التقييم هذا انتهت صلاحيته أو لم يعد صالحاً.', goSpace: 'ادخلي مساحتي في إليراتي', rvAllDone: 'قيّمتِ كل قطع هذا الطلب. شكراً لكِ!',
    nextItem: 'قيّمي قطعة أخرى',
    accountTitle: 'حسابي', accountLead: 'بياناتكِ للطلبات والتوصيل.', emailLabel: 'البريد الإلكتروني',
    phoneLabel: 'رقم واتساب', phoneHint: 'لتحديثات التوصيل واتصال المندوب.', save: 'حفظ', saved: 'تم الحفظ.',
    ePhone: 'أدخلي رقماً صحيحاً مع رمز الدولة، مثل ‎+971 50 123 4567‎.',
    helpTitle: 'المساعدة والتواصل', helpLead: 'راسلينا، نرد عليكِ بسرعة.', whatsapp: 'واتساب', whatsappText: 'أسرع طريقة للتواصل معنا',
    mailText: 'نرد على كل رسالة', shipping: 'سياسة الشحن', returns: 'سياسة الإرجاع', contactPage: 'صفحة التواصل', trackPage: 'تتبّعي طرداً',
    faqTitle: 'أسئلة متكررة',
    faq: [
      ['كم يستغرق التوصيل؟', 'من 5 إلى 7 أيام بعد طلبكِ. تجدين التواريخ المتوقعة في طلبكِ هنا في مساحتكِ.'],
      ['هل أقدر أرجّع قطعة؟', 'نعم، خلال 14 يوماً من التوصيل. راسلينا على واتساب ونرشدكِ.'],
      ['كيف أتتبّع طردي؟', 'يظهر رقم التتبع في «طلباتي» أول ما ينشحن طردكِ. اضغطي «تتبّعي طردي».'],
      ['هل أقدر أغيّر عنوان التوصيل؟', 'راسلينا على واتساب في أسرع وقت، ويُفضّل قبل شحن طردكِ.']
    ],
    loadError: 'تعذّر تحميل مساحتكِ. تحققي من اتصالكِ وحاولي مرة ثانية.', retry: 'حاولي مرة ثانية',
    sessionEnded: 'انتهت جلستكِ. أدخلي بريدكِ الإلكتروني لتسجيل الدخول مرة ثانية.',
    eEmail: 'أدخلي بريداً إلكترونياً صحيحاً.', eCode: 'أدخلي أرقام الكود الستة.', eMismatch: 'هذا الكود غير صحيح. تأكدي منه وحاولي مرة ثانية.',
    eExpired: 'انتهت صلاحية هذا الكود. اطلبي كوداً جديداً بالأسفل.', eRateLogin: 'محاولات كثيرة. انتظري بضع دقائق ثم حاولي مرة ثانية.',
    resendIn: 'إعادة إرسال الكود بعد {s} ث', resend: 'أعيدي إرسال الكود', resent: 'كود جديد في الطريق.'
  }
};

const STAGES = ['placed', 'prepared', 'shipped', 'out', 'delivered'];
const TABS = ['home', 'orders', 'codes', 'reviews', 'account', 'help'];
const NAV_ICONS = { home: 'home', orders: 'box', codes: 'tag', reviews: 'starLine', account: 'user', help: 'help' };
const MAX_PHOTOS = 3;
const MAX_SIDE = 1600;
const RESEND_AFTER = 45;

const ICONS = {
  copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="8" y="8" width="12" height="12"/><path d="M16 8V4H4v12h4"/></svg>',
  check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  chev: '<svg class="els-order__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>',
  star: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.8 5.9 6.5.8-4.8 4.5 1.2 6.4L12 17.3l-5.7 3.1 1.2-6.4-4.8-4.5 6.5-.8z"/></svg>',
  camera: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 8h3l2-2.5h6L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>',
  wa: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.7.3-.2.3-.9.9-.9 2.2s.9 2.5 1 2.7c.1.2 1.8 2.8 4.4 3.9 1.6.7 2.3.8 3.1.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/></svg>',
  mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="3" y="5.5" width="18" height="13"/><path d="M3.5 6l8.5 7 8.5-7"/></svg>',
  home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M4 11l8-6.5L20 11v9H4z"/><path d="M10 20v-5h4v5"/></svg>',
  box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M4 8l8-4 8 4v9l-8 4-8-4z"/><path d="M4 8l8 4 8-4M12 12v9"/></svg>',
  tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M4 7h16v3.5a1.8 1.8 0 0 0 0 3V17H4v-3.5a1.8 1.8 0 0 0 0-3z"/><path d="M14.5 7v2m0 2.5v1m0 2.5v2"/></svg>',
  starLine: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M12 3.6l2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 17l-5.2 2.8 1-5.9L3.5 9.8l5.9-.8z"/></svg>',
  user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><circle cx="12" cy="8.5" r="4"/><path d="M4.5 20.5c1-4 4-6 7.5-6s6.500 2 7.500 6"/></svg>',
  help: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M4 5h16v12H9.500L5.500 20.500V17H4z"/><path d="M9.800 9.300a2.200 2.200 0 1 1 3.400 1.900c-.8.500-1.200.9-1.200 1.800M12 15v.1"/></svg>',
  arrow: '<svg class="els-flip" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
};


function start() {
  const lang = root.dataset.lang === 'ar' ? 'ar' : 'en';
  const T = COPY[lang];
  const locale = lang === 'ar' ? 'ar-AE-u-nu-latn' : 'en-GB';
  const API = (root.dataset.api || '').replace(/\/$/, '');
  const BASE = (root.dataset.root || '/').replace(/\/$/, '');
  const params = new URLSearchParams(location.search);
  const mock = params.has('mock') ? new Set((params.get('mock') || '1').split(',')) : null;
  const live = root.querySelector('[data-live]');
  const appBox = root.querySelector('[data-view="app"]');
  const reviewBox = root.querySelector('[data-view="review"]');

  let token = store.get();
  let me = null;
  const open = new Set();
  const reviewedNow = new Set();

  /* ---------- utilitaires ---------- */

  const fmt = (s, v = {}) => String(s).replace(/\{(\w+)\}/g, (_, k) => (v[k] ?? ''));
  const setState = (s) => { root.dataset.state = s; };
  const announce = (text) => { live.textContent = ''; setTimeout(() => { live.textContent = text; }, 40); };
  const link = (path) => BASE + path;

  function h(tag, attrs, ...kids) {
    const el = document.createElement(tag);
    if (attrs) {
      for (const [k, v] of Object.entries(attrs)) {
        if (v == null || v === false) continue;
        if (k === 'class') el.className = v;
        else if (k === 'text') el.textContent = v;
        else if (k === 'icon') el.insertAdjacentHTML('afterbegin', ICONS[v]);
        else if (k.startsWith('on')) el.addEventListener(k.slice(2), v);
        else el.setAttribute(k, v === true ? '' : v);
      }
    }
    for (const kid of kids.flat(Infinity)) {
      if (kid == null || kid === false) continue;
      el.append(kid instanceof Node ? kid : String(kid));
    }
    return el;
  }

  // Liens venant de l'API : seulement http(s) ou chemins du site.
  function safeUrl(u) {
    if (!u) return null;
    const s = String(u).trim();
    if (s.startsWith('/') && !s.startsWith('//')) return s;
    try {
      const url = new URL(s);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
    } catch {
      return null;
    }
  }

  function parseDate(v) {
    if (!v) return null;
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(v);
    return isNaN(d) ? null : d;
  }
  function fmtDate(v, opts = { day: 'numeric', month: 'long', year: 'numeric' }) {
    const d = parseDate(v);
    return d ? new Intl.DateTimeFormat(locale, opts).format(d) : '';
  }
  function fmtMoney(amount, currency) {
    const n = typeof amount === 'number' ? amount : Number(String(amount ?? '').replace(/,/g, ''));
    if (!isFinite(n) || !currency) return [amount, currency].filter(Boolean).join(' ');
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: n % 1 ? 2 : 0 }).format(n);
    } catch {
      return `${n} ${currency}`;
    }
  }
  // Chiffres arabes (٠-٩) et persans (۰-۹) d'un clavier arabe convertis en chiffres latins.
  const digits = (v) => String(v || '')
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0))
    .replace(/\D/g, '');

  function contact() {
    const c = (me && me.contact) || {};
    return {
      whatsappUrl: safeUrl(c.whatsappUrl) || root.dataset.whatsapp,
      whatsapp: c.whatsapp || '+971 58 510 1654',
      email: c.email || root.dataset.email
    };
  }

  async function copyText(text) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      const ta = h('textarea', { style: 'position:fixed;opacity:0', readonly: true });
      ta.value = text;
      document.body.append(ta);
      ta.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch {}
      ta.remove();
      return ok;
    }
  }
  function copyButton(text, label) {
    const btn = h('button', { type: 'button', class: 'els-copy', 'aria-label': `${T.copy} ${label || text}` }, h('span', { icon: 'copy' }), h('span', { text: T.copy }));
    btn.addEventListener('click', async () => {
      if (!(await copyText(text))) return;
      btn.classList.add('is-done');
      btn.lastChild.textContent = T.copied;
      announce(fmt(T.copiedLive, { text }));
      clearTimeout(btn._t);
      btn._t = setTimeout(() => { btn.classList.remove('is-done'); btn.lastChild.textContent = T.copy; }, 2200);
    });
    return btn;
  }

  /* ---------- API ---------- */

  async function api(path, { method = 'GET', json, form, auth, query } = {}) {
    if (mock) return mockApi(path, method, json, form, auth, query);
    const headers = {};
    if (auth) headers.Authorization = 'Bearer ' + auth;
    let body;
    if (json) {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(json);
    } else if (form) body = form;
    const url = API + path + (query ? '?' + new URLSearchParams(query) : '');
    let res;
    try {
      res = await fetch(url, { method, headers, body, credentials: 'omit', mode: 'cors' });
    } catch {
      return { ok: false, status: 0, data: { error: 'network' } };
    }
    const data = await res.json().catch(() => ({}));
    return { ok: res.ok, status: res.status, data: data || {} };
  }

  /* ---------- connexion ---------- */

  const login = root.querySelector('[data-view="login"]');
  const emailForm = login.querySelector('[data-step="email"]');
  const codeForm = login.querySelector('[data-step="code"]');
  const emailInput = emailForm.querySelector('input');
  const codeInput = codeForm.querySelector('[data-code-input]');
  const codeWrap = codeForm.querySelector('.els-code');
  const cells = [...codeForm.querySelectorAll('[data-cell]')];
  const loginError = login.querySelector('[data-login-error]');
  const loginNote = login.querySelector('[data-login-note]');
  const resendBtn = codeForm.querySelector('[data-resend]');
  let email = '';
  let timer = 0;
  let lastTried = '';

  function loginErr(msg) {
    loginError.textContent = msg || '';
    loginError.hidden = !msg;
  }
  function busy(form, on) {
    const btn = form.querySelector('[type="submit"]');
    if (on) {
      btn.dataset.label = btn.textContent;
      btn.textContent = btn.dataset.busy;
    } else if (btn.dataset.label) btn.textContent = btn.dataset.label;
    btn.disabled = on;
    form.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function paintCells() {
    const v = codeInput.value;
    cells.forEach((c, i) => {
      c.textContent = v[i] || '';
      c.classList.toggle('is-active', i === Math.min(v.length, 5));
    });
  }
  function countdown() {
    clearInterval(timer);
    let left = RESEND_AFTER;
    resendBtn.disabled = true;
    resendBtn.textContent = fmt(T.resendIn, { s: left });
    timer = setInterval(() => {
      left -= 1;
      if (left <= 0) {
        clearInterval(timer);
        resendBtn.disabled = false;
        resendBtn.textContent = T.resend;
      } else resendBtn.textContent = fmt(T.resendIn, { s: left });
    }, 1000);
  }
  function showLogin(note) {
    loginNote.textContent = note || '';
    loginNote.hidden = !note;
    loginErr('');
    emailForm.hidden = false;
    codeForm.hidden = true;
    setState('login');
  }
  function loginError429(r) {
    if (r.status === 429 || r.data.error === 'rate') return T.eRateLogin;
    if (r.status === 0) return T.eNetwork;
    return T.eServer;
  }

  emailForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    loginErr('');
    const value = emailInput.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
      emailInput.setAttribute('aria-invalid', 'true');
      loginErr(T.eEmail);
      emailInput.focus();
      return;
    }
    emailInput.removeAttribute('aria-invalid');
    busy(emailForm, true);
    const r = await api('/login', { method: 'POST', json: { email: value, lang } });
    busy(emailForm, false);
    if (!r.ok) return loginErr(loginError429(r));
    email = value;
    codeForm.querySelector('[data-email]').textContent = email;
    loginNote.hidden = true;
    emailForm.hidden = true;
    codeForm.hidden = false;
    codeInput.value = '';
    lastTried = '';
    paintCells();
    countdown();
    codeInput.focus();
  });

  codeInput.addEventListener('input', () => {
    const v = digits(codeInput.value).slice(0, 6);
    if (codeInput.value !== v) codeInput.value = v;
    codeWrap.classList.remove('is-error');
    paintCells();
    if (v.length === 6 && v !== lastTried) codeForm.requestSubmit();
  });
  for (const ev of ['focus', 'blur', 'keyup', 'click']) codeInput.addEventListener(ev, paintCells);

  codeForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    loginErr('');
    const code = digits(codeInput.value);
    if (code.length !== 6) {
      codeWrap.classList.add('is-error');
      loginErr(T.eCode);
      codeInput.focus();
      return;
    }
    lastTried = code;
    busy(codeForm, true);
    const r = await api('/verify', { method: 'POST', json: { email, code, lang } });
    busy(codeForm, false);
    if (!r.ok || !r.data.token) {
      codeWrap.classList.add('is-error');
      const err = r.data.error;
      loginErr(err === 'expired' ? T.eExpired : err === 'mismatch' || r.status === 400 ? T.eMismatch : loginError429(r));
      codeInput.select();
      codeInput.focus();
      return;
    }
    clearInterval(timer);
    token = r.data.token;
    store.set(token);
    loadMe(true);
  });

  resendBtn.addEventListener('click', async () => {
    loginErr('');
    countdown();
    const r = await api('/login', { method: 'POST', json: { email, lang } });
    if (!r.ok) return loginErr(loginError429(r));
    announce(T.resent);
    loginNote.textContent = T.resent;
    loginNote.hidden = false;
    codeInput.focus();
  });

  codeForm.querySelector('[data-change-email]').addEventListener('click', () => {
    clearInterval(timer);
    showLogin();
    emailInput.select();
    emailInput.focus();
  });

  /* ---------- espace connectée ---------- */

  async function loadMe(fresh) {
    setState('loading');
    const r = await api('/me', { auth: token });
    if (r.status === 401) {
      store.del();
      token = null;
      showLogin(fresh ? '' : T.sessionEnded);
      return;
    }
    if (!r.ok) {
      appBox.replaceChildren(h('div', { class: 'els-empty', style: 'margin:48px 16px' },
        h('p', { role: 'alert', text: T.loadError }),
        h('button', { type: 'button', class: 'els-btn', onclick: () => loadMe() }, T.retry)));
      setState('app');
      return;
    }
    me = normalize(r.data);
    renderApp();
    setState('app');
    if (fresh) {
      root.scrollIntoView({ block: 'start' });
      appBox.querySelector('.els-title')?.focus({ preventScroll: true });
    }
  }

  function normalize(d) {
    const orders = Array.isArray(d.orders) ? d.orders.slice() : [];
    orders.sort((a, b) => (parseDate(b.createdAt) || 0) - (parseDate(a.createdAt) || 0));
    return { ...d, orders };
  }

  const stageOf = (o) => (o.stage === 'cancelled' ? 'cancelled' : STAGES.includes(o.stage) ? o.stage : STAGES[Math.max(0, Math.min(4, Number(o.stageIndex) || 0))]);
  const stageIdx = (o) => STAGES.indexOf(stageOf(o));
  const isActive = (o) => !['delivered', 'cancelled'].includes(stageOf(o));
  const heroOrder = () => me.orders.find(isActive) || me.orders[0] || null;
  const reviewables = () => {
    const seen = new Set();
    const list = [];
    for (const o of me.orders) {
      if (!o.reviewable) continue;
      for (const it of o.items || []) {
        if (!it.productId || seen.has(String(it.productId))) continue;
        seen.add(String(it.productId));
        list.push({ ...it, order: o });
      }
    }
    return list;
  };

  function renderApp() {
    const name = (me.firstName || '').trim();
    const pending = reviewables().filter((i) => !reviewedNow.has(String(i.productId))).length;
    const nav = h('nav', { class: 'els-nav', 'aria-label': T.navLabel },
      h('ul', null, TABS.map((tab) => h('li', null,
        h('a', { href: '#' + tab, 'data-tab': tab },
          h('span', { class: 'els-nav__icon', icon: NAV_ICONS[tab] }),
          h('span', { class: 'els-nav__long', text: T.nav[tab] }),
          h('span', { class: 'els-nav__short', text: T.navShort[tab] }),
          tab === 'reviews' && pending ? h('span', { class: 'els-nav__count', 'aria-hidden': 'true', text: pending }) : null)))));
    const panel = h('div', { class: 'els-panel', 'data-panel': true });
    appBox.replaceChildren(
      h('header', { class: 'els-mast' },
        h('div', { class: 'els-mast__in' },
          h('div', null,
            h('p', { class: 'els-eyebrow', text: T.spaceEyebrow }),
            h('h1', { class: 'els-title', tabindex: '-1', text: name ? fmt(T.hello, { name }) : T.helloPlain })),
          h('div', { class: 'els-mast__side' },
            me.email ? h('span', { class: 'els-mast__mail' }, h('bdi', { dir: 'ltr', text: me.email })) : null,
            h('button', { type: 'button', class: 'els-linkbtn', onclick: logout, text: T.logout })))),
      nav,
      panel);
    route(false);
  }

  function currentTab() {
    const [tab, arg] = location.hash.replace(/^#/, '').split('/');
    return { tab: TABS.includes(tab) ? tab : 'home', arg: arg ? decodeURIComponent(arg) : '' };
  }

  function route(userAction) {
    if (!me) return;
    const { tab, arg } = currentTab();
    const panel = appBox.querySelector('[data-panel]');
    if (!panel) return;
    appBox.querySelectorAll('[data-tab]').forEach((a) => {
      if (a.dataset.tab === tab) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
    if (tab === 'orders' && arg) open.add(arg);
    const views = { home: viewHome, orders: viewOrders, codes: viewCodes, reviews: viewReviews, account: viewAccount, help: viewHelp };
    panel.replaceChildren(...[].concat(views[tab](arg)).filter(Boolean));
    if (!userAction) return;
    const target = (tab === 'orders' && arg && panel.querySelector(`[data-order="${CSS.escape(arg)}"]`)) || panel;
    const top = target.getBoundingClientRect().top;
    if (top < 80 || top > innerHeight * 0.6) target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    panel.querySelector('.els-h2, .els-hero__title')?.setAttribute('tabindex', '-1');
    panel.querySelector('.els-h2, .els-hero__title')?.focus({ preventScroll: true });
  }
  window.addEventListener('hashchange', () => route(true));

  function logout() {
    store.del();
    token = null;
    me = null;
    open.clear();
    appBox.replaceChildren();
    if (location.hash) history.replaceState(null, '', location.pathname + location.search);
    showLogin();
    root.scrollIntoView({ block: 'start' });
    root.querySelector('[data-login-title]')?.focus({ preventScroll: true });
  }

  function panelHead(title, lead) {
    return h('div', { class: 'els-panel__head' }, h('h2', { class: 'els-h2', tabindex: '-1', text: title }), lead ? h('p', { text: lead }) : null);
  }

  // Images Shopify : même fichier, à la largeur demandée (l'API renvoie parfois une petite vignette).
  function sized(u, width) {
    const safe = safeUrl(u);
    if (!safe || !/\/\/cdn\.shopify\.com\/|\/cdn\/shop\//.test(safe)) return safe;
    try {
      const url = new URL(safe, location.origin);
      url.searchParams.set('width', width);
      return url.href;
    } catch {
      return safe;
    }
  }

  /* ---------- briques commande ---------- */

  // Date attendue en grand ; rien si la commande est en retard (la note de retard prend le relais, pas de date passée).
  function etaBlock(o) {
    const st = stageOf(o);
    if (st === 'cancelled') return h('p', { class: 'els-when' }, T.cancelledNote, ' ', h('a', { href: contact().whatsappUrl, target: '_blank', rel: 'noopener', class: 'els-link', text: T.whatsappUs }));
    const day = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' });
    const weekday = new Intl.DateTimeFormat(locale, { weekday: 'long' });
    const block = (label, date, sub) => h('div', { class: 'els-eta' },
      h('p', { class: 'els-h3', text: label }),
      h('p', { class: 'els-eta__date', text: date }),
      sub ? h('p', { class: 'els-eta__sub', text: sub }) : null);
    if (st === 'delivered') {
      const d = parseDate(o.deliveredAt);
      return d ? block(T.stages.delivered, day.format(d), weekday.format(d)) : null;
    }
    if (o.late) return null;
    const a = parseDate(o.eta && o.eta.from);
    const b = parseDate(o.eta && o.eta.to);
    if (!a && !b) return null;
    if (a && b && a < b) return block(T.etaLabel, day.formatRange(a, b), `${weekday.format(a)} – ${weekday.format(b)}`);
    return block(T.etaLabel, day.format(a || b), weekday.format(a || b));
  }
  // Texte avec les valeurs en gras, sans innerHTML.
  function splitBold(tpl, vars) {
    return tpl.split(/(\{\w+\})/).filter(Boolean).map((part) => {
      const m = /^\{(\w+)\}$/.exec(part);
      return m ? h('strong', { text: vars[m[1]] ?? '' }) : part;
    });
  }

  function timeline(o) {
    if (stageOf(o) === 'cancelled') return null;
    const idx = stageIdx(o);
    return h('ol', { class: 'els-steps', 'aria-label': T.progress }, STAGES.map((s, i) =>
      h('li', { class: i < idx ? 'is-done' : i === idx ? 'is-now' : '', 'aria-current': i === idx ? 'step' : null, style: `--i:${i}` },
        h('span', { class: 'els-steps__dot', 'aria-hidden': 'true' }),
        h('span', { class: 'els-steps__label', text: T.stages[s] }))));
  }

  function lateNote(o) {
    if (!o.late || !isActive(o)) return null;
    return h('p', { class: 'els-late', role: 'status' }, T.late, ' ', h('a', { href: contact().whatsappUrl, target: '_blank', rel: 'noopener', text: T.lateLink }));
  }

  function trackingBlock(o) {
    const st = stageOf(o);
    if (st === 'cancelled') return null;
    const tr = o.tracking;
    if (!tr || !tr.code) {
      return ['placed', 'prepared'].includes(st) ? h('div', { class: 'els-track' }, h('p', { class: 'els-track__wait', text: T.noTracking })) : null;
    }
    const url = safeUrl(tr.url);
    const c = o.carrier;
    return h('div', { class: 'els-track' },
      h('div', null,
        h('p', { class: 'els-h3', text: T.trackingLabel }),
        h('div', { class: 'els-track__row' },
          h('span', { class: 'els-track__code', dir: 'ltr', text: tr.code }),
          copyButton(String(tr.code).replace(/\s+/g, ''), T.trackingLabel))),
      c && c.lastEvent ? h('p', { class: 'els-track__event' }, `${T.latest}: `, h('span', { dir: 'auto', text: c.lastEvent }), c.lastAt ? ` · ${fmtDate(c.lastAt, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}` : '') : null,
      url && isActive(o) ? h('a', { class: 'els-btn', href: url }, T.follow, h('span', { icon: 'arrow' })) : null);
  }

  function heroMedia(o) {
    const pieces = (o.items || []).filter((it) => safeUrl(it.image)).slice(0, 3);
    return h('figure', { class: 'els-hero__media', 'data-n': Math.max(1, pieces.length) },
      h('p', { class: 'els-hero__num' }, h('span', { dir: 'ltr', text: o.name || '' }), ' · ', fmtDate(o.createdAt, { day: 'numeric', month: 'short' })),
      pieces.map((it, i) => h('span', { class: 'els-hero__piece' },
        h('img', { src: sized(it.image, 800), alt: it.title || '', loading: i ? 'lazy' : 'eager' }),
        it.quantity > 1 ? h('span', { class: 'els-qty', dir: 'ltr', text: '×' + it.quantity }) : null)));
  }

  function heroCard(o) {
    const st = stageOf(o);
    return h('article', { class: 'els-hero' },
      heroMedia(o),
      h('div', { class: 'els-hero__body' },
        h('p', { class: 'els-eyebrow', text: isActive(o) ? T.currentOrder : T.lastOrder }),
        h('h2', { class: 'els-hero__title', text: T.titles[st] }),
        etaBlock(o),
        lateNote(o),
        timeline(o),
        trackingBlock(o),
        h('div', { class: 'els-hero__foot' },
          h('a', { class: 'els-link', href: '#orders/' + encodeURIComponent(o.number ?? o.name) }, T.seeOrder, h('span', { icon: 'arrow' })))));
  }

  function addressCard(o) {
    const url = safeUrl(o.shortAddress && o.shortAddress.url);
    return h('section', { class: 'els-callout', 'aria-label': T.addrTitle },
      h('p', { class: 'els-eyebrow' }, h('bdi', { text: o.name || '' })),
      h('p', { class: 'els-callout__title', text: T.addrTitle }),
      h('p', { text: T.addrText }),
      url ? h('a', { class: 'els-btn', href: url }, T.addrCta) : h('a', { class: 'els-btn', href: contact().whatsappUrl, target: '_blank', rel: 'noopener' }, T.whatsappUs));
  }

  /* ---------- vues ---------- */

  function viewHome() {
    const o = heroOrder();
    const out = [];
    const missing = me.orders.find((x) => isActive(x) && x.shortAddress && x.shortAddress.missing);
    if (missing) out.push(addressCard(missing));
    out.push(o ? heroCard(o) : emptyOrders());
    const tiles = [];
    if (me.promo && me.promo.code) {
      tiles.push(h('section', { class: 'els-tile els-card-noir' },
        h('p', { class: 'els-eyebrow', text: T.teaserCode }),
        me.promo.percent ? h('p', { class: 'els-tile__pct' }, h('bdi', { dir: 'ltr', text: fmt(T.promoPct, { percent: me.promo.percent }) })) : null,
        h('p', { class: 'els-tile__code', dir: 'ltr', text: me.promo.code }),
        h('a', { class: 'els-link', href: '#codes' }, T.seeCodes, h('span', { icon: 'arrow' }))));
    }
    const pending = reviewables().filter((i) => !reviewedNow.has(String(i.productId)));
    if (pending.length) {
      tiles.push(h('section', { class: 'els-tile' },
        h('p', { class: 'els-tile__stars', 'aria-hidden': 'true' }, [1, 2, 3, 4, 5].map(() => h('span', { icon: 'star' }))),
        h('p', { class: 'els-tile__title', text: T.teaserReview }),
        h('p', { class: 'els-muted', text: T.teaserReviewText }),
        h('a', { class: 'els-btn els-btn--ghost els-btn--sm', href: '#reviews' }, T.reviewIt)));
    }
    tiles.push(h('section', { class: 'els-tile' },
      h('span', { class: 'els-contact__icon', icon: 'wa' }),
      h('p', { class: 'els-tile__title', text: T.helpTitle }),
      h('p', { class: 'els-muted', text: T.helpLead }),
      h('a', { class: 'els-btn els-btn--ghost els-btn--sm', href: contact().whatsappUrl, target: '_blank', rel: 'noopener' }, T.whatsappUs)));
    out.push(h('div', { class: 'els-tiles' }, tiles));
    const others = me.orders.filter((x) => x !== o).slice(0, 3);
    if (others.length) {
      out.push(h('section', null,
        h('div', { class: 'els-others__head' },
          h('p', { class: 'els-h3', text: T.otherOrders }),
          h('a', { class: 'els-link', href: '#orders' }, T.allOrders, h('span', { icon: 'arrow' }))),
        h('ul', { class: 'els-mini' }, others.map((x) => {
          const first = (x.items || [])[0];
          const st = stageOf(x);
          return h('li', null, h('a', { href: '#orders/' + encodeURIComponent(x.number ?? x.name) },
            h('span', { class: 'els-mini__img' }, first && safeUrl(first.image) ? h('img', { src: sized(first.image, 200), alt: '', loading: 'lazy', width: 56, height: 56 }) : null),
            h('span', { style: 'min-width:0' },
              h('span', { class: 'els-mini__name' }, h('bdi', { text: x.name || '' }), first ? ` · ${first.title || ''}` : ''),
              h('span', { class: 'els-mini__sub', text: fmtDate(x.createdAt) })),
            h('span', { class: `els-pill els-pill--${st}`, text: T.stages[st] })));
        }))));
    }
    return out;
  }

  function emptyOrders() {
    return h('div', { class: 'els-empty' },
      h('p', { class: 'els-callout__title', text: T.noOrders }),
      h('p', { class: 'els-muted', text: T.noOrdersText }),
      h('a', { class: 'els-btn', href: link('/collections/all') }, T.shop));
  }

  function viewOrders() {
    if (!me.orders.length) return [panelHead(T.ordersTitle), emptyOrders()];
    const now = me.orders.filter(isActive);
    const past = me.orders.filter((o) => !isActive(o));
    const group = (label, list) => (list.length ? h('section', { class: 'els-group' },
      h('p', { class: 'els-h3', text: label }),
      h('ul', { class: 'els-orders' }, list.map(orderRow))) : null);
    return [panelHead(T.ordersTitle, T.ordersLead), group(T.inProgress, now), group(T.pastOrders, past)];
  }

  function orderRow(o) {
    const key = String(o.number ?? o.name);
    const id = 'els-o-' + key.replace(/\W/g, '');
    const st = stageOf(o);
    const items = o.items || [];
    const first = items[0];
    const expanded = open.has(key);
    const body = h('div', { class: 'els-order__body', id, hidden: !expanded }, expanded ? orderDetail(o) : null);
    const head = h('button', { type: 'button', class: 'els-order__head', 'aria-expanded': String(expanded), 'aria-controls': id },
      h('span', { class: 'els-mosaic' }, items.slice(0, 3).map((it) =>
        h('span', { class: 'els-mosaic__img' }, safeUrl(it.image) ? h('img', { src: sized(it.image, 240), alt: '', loading: 'lazy', width: 84, height: 84 }) : null))),
      h('span', { style: 'min-width:0' },
        h('span', { class: 'els-order__name' }, h('bdi', { text: o.name || '' })),
        first ? h('span', { class: 'els-order__piece' }, first.title || '', items.length > 1 ? h('bdi', { dir: 'ltr', text: ` +${items.length - 1}` }) : null) : null,
        h('span', { class: 'els-order__sub', text: `${fmtDate(o.createdAt)} · ${fmtMoney(o.total, o.currency)}` })),
      h('span', { class: 'els-order__end' },
        h('span', { class: `els-pill els-pill--${st}`, text: T.stages[st] }),
        h('span', { icon: 'chev' })));
    head.addEventListener('click', () => {
      const now = head.getAttribute('aria-expanded') !== 'true';
      head.setAttribute('aria-expanded', String(now));
      if (now) {
        open.add(key);
        if (!body.childNodes.length) body.append(...orderDetail(o));
      } else open.delete(key);
      body.hidden = !now;
    });
    return h('li', { class: 'els-order', 'data-order': key }, head, body);
  }

  function orderDetail(o) {
    const st = stageOf(o);
    const items = o.items || [];
    const reorder = safeUrl(o.reorderUrl);
    const lines = (o.address || []).filter(Boolean);
    return [
      h('div', { class: 'els-detail' },
        h('div', { style: 'min-width:0' },
          etaBlock(o),
          lateNote(o),
          timeline(o),
          trackingBlock(o),
          h('div', { style: 'margin-top:28px' },
            h('p', { class: 'els-h3', text: T.items }),
            h('ul', { class: 'els-items' }, items.map((it) => {
              const href = safeUrl(it.href);
              const title = href ? h('a', { href, text: it.title || '' }) : h('span', { class: 'els-items__title', text: it.title || '' });
              return h('li', null,
                h('span', { class: 'els-items__img' }, safeUrl(it.image) ? h('img', { src: sized(it.image, 240), alt: '', loading: 'lazy', width: 76, height: 76 }) : null),
                h('span', null, title,
                  it.variant && it.variant !== 'Default Title' ? h('small', { text: it.variant }) : null,
                  h('small', { text: fmt(T.qty, { n: it.quantity || 1 }) })));
            })))),
        h('aside', { class: 'els-facts' },
          h('div', null, h('p', { class: 'els-h3', text: T.total }), h('p', { class: 'els-total', text: fmtMoney(o.total, o.currency) })),
          lines.length ? h('div', null, h('p', { class: 'els-h3', text: T.address }), ...lines.map((l) => h('p', { dir: 'auto', text: l }))) : null,
          h('div', { class: 'els-actions' },
            reorder && st !== 'cancelled' ? h('a', { class: 'els-btn els-btn--sm', href: reorder }, T.reorder) : null,
            reorder && st === 'cancelled' ? h('a', { class: 'els-btn els-btn--ghost els-btn--sm', href: reorder }, T.reorder) : null,
            o.reviewable ? h('a', { class: 'els-btn els-btn--ghost els-btn--sm', href: '#reviews' }, T.reviewIt) : null),
          o.canReturn ? h('div', { class: 'els-return' },
            h('p', { class: 'els-h3', style: 'margin-bottom:6px', text: T.returnTitle }),
            h('p', { text: T.returnText }),
            h('p', { style: 'margin:0' },
              h('a', { href: link('/policies/refund-policy'), text: T.returnPolicy }), ' · ',
              h('a', { href: contact().whatsappUrl, target: '_blank', rel: 'noopener', text: T.whatsappUs }))) : null))
    ];
  }

  function viewCodes() {
    const p = me.promo;
    const out = [panelHead(T.codesTitle, T.codesLead)];
    if (p && p.code) {
      const url = safeUrl(p.url);
      out.push(h('section', { class: 'els-promo els-card-noir' },
        h('div', null,
          h('p', { class: 'els-eyebrow', text: T.promoKicker }),
          p.percent ? h('p', { class: 'els-promo__pct' }, h('bdi', { dir: 'ltr', text: fmt(T.promoPct, { percent: p.percent }) })) : null),
        h('div', null,
          h('p', { class: 'els-promo__text', text: T.promoText }),
          h('div', { class: 'els-promo__code' }, h('code', { dir: 'ltr', text: p.code }), copyButton(p.code)),
          url ? h('div', { class: 'els-promo__actions' }, h('a', { class: 'els-btn els-btn--light', href: url }, T.useIt, h('span', { icon: 'arrow' }))) : null)));
    } else out.push(h('div', { class: 'els-empty' }, h('p', { class: 'els-muted', text: T.noCode })));
    const offer = me.offer;
    if (offer && typeof offer === 'object' && (offer.title || offer.text)) {
      const url = safeUrl(offer.url);
      out.push(h('section', { class: 'els-tile', style: 'min-height:0' },
        offer.title ? h('p', { class: 'els-tile__title', text: offer.title }) : null,
        offer.text ? h('p', { class: 'els-muted', text: offer.text }) : null,
        url ? h('a', { class: 'els-btn els-btn--ghost els-btn--sm', href: url }, offer.cta || T.useIt) : null));
    }
    return out;
  }

  function viewReviews() {
    const list = reviewables();
    const out = [panelHead(T.reviewsTitle, T.reviewsLead)];
    if (!list.length) {
      out.push(h('div', { class: 'els-empty' }, h('p', { class: 'els-muted', text: T.noReviewable })));
      return out;
    }
    let current = null;
    const ul = h('ul', { class: 'els-rlist' });
    for (const it of list) {
      const pid = String(it.productId);
      const formBox = h('div', { class: 'els-ritem__form', hidden: true });
      const done = reviewedNow.has(pid);
      const btn = done
        ? h('span', { class: 'els-ritem__done' }, h('span', { icon: 'check', style: 'width:16px;height:16px;display:inline-flex' }), T.reviewed)
        : h('button', { type: 'button', class: 'els-btn els-btn--ghost els-btn--sm', 'aria-expanded': 'false' }, T.reviewThis);
      if (!done) {
        btn.addEventListener('click', () => {
          if (current && current !== formBox) {
            current.hidden = true;
            current.replaceChildren();
            current.previousElementSibling.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
          }
          const show = formBox.hidden;
          formBox.hidden = !show;
          btn.setAttribute('aria-expanded', String(show));
          formBox.replaceChildren();
          current = show ? formBox : null;
          if (show) {
            formBox.append(reviewForm({
              productId: it.productId,
              defaultName: me.firstName,
              auth: { token, order: it.order && it.order.name },
              onDone: () => {
                reviewedNow.add(pid);
                btn.replaceWith(h('span', { class: 'els-ritem__done' }, h('span', { icon: 'check', style: 'width:16px;height:16px;display:inline-flex' }), T.reviewed));
                const badge = appBox.querySelector('.els-nav__count');
                const left = reviewables().filter((i) => !reviewedNow.has(String(i.productId))).length;
                if (badge) { if (left) badge.textContent = left; else badge.remove(); }
              }
            }));
            formBox.querySelector('input')?.focus();
          }
        });
      }
      ul.append(h('li', { class: 'els-ritem' },
        h('div', { class: 'els-ritem__row' },
          safeUrl(it.image) ? h('img', { src: sized(it.image, 240), alt: '', loading: 'lazy', width: 84, height: 84 }) : h('span'),
          h('div', { style: 'min-width:0' }, h('p', { class: 'els-ritem__title', text: it.title || '' }), h('p', { class: 'els-ritem__sub' }, fmt(T.fromOrder, { name: '' }), h('span', { dir: 'ltr', text: it.order.name || '' }))),
          btn),
        formBox));
    }
    out.push(ul);
    return out;
  }

  function viewAccount() {
    const input = h('input', { class: 'els-input', id: 'ElsPhone', type: 'tel', name: 'whatsapp', autocomplete: 'tel', inputmode: 'tel', dir: 'ltr', placeholder: '+971 50 123 4567', 'aria-describedby': 'ElsPhoneHint ElsPhoneMsg' });
    input.value = me.whatsapp || '';
    const msg = h('p', { id: 'ElsPhoneMsg', 'aria-live': 'polite', class: 'els-ok', hidden: true });
    const btn = h('button', { type: 'submit', class: 'els-btn' }, T.save);
    const form = h('form', { class: 'els-ledger__row', novalidate: true },
      h('div', { class: 'els-ledger__key' },
        h('label', { class: 'els-label', for: 'ElsPhone', text: T.phoneLabel }),
        h('p', { class: 'els-hint', id: 'ElsPhoneHint', text: T.phoneHint })),
      h('div', { class: 'els-ledger__val' },
        h('div', { class: 'els-form-row' }, input, btn),
        msg));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const raw = input.value.trim();
      const n = digits(raw);
      const say = (text, ok) => { msg.textContent = text; msg.className = ok ? 'els-ok' : 'els-error'; msg.hidden = false; };
      if (n.length < 8 || n.length > 15) {
        input.setAttribute('aria-invalid', 'true');
        return say(T.ePhone, false);
      }
      input.removeAttribute('aria-invalid');
      const value = (raw.trim().startsWith('+') || raw.trim().startsWith('00') ? '+' : '') + n.replace(/^00/, '');
      btn.disabled = true;
      const r = await api('/phone', { method: 'POST', json: { whatsapp: value }, auth: token });
      btn.disabled = false;
      if (r.status === 401) return loadMe();
      if (!r.ok) return say(r.data.error === 'invalid' ? T.ePhone : r.status === 0 ? T.eNetwork : T.eServer, false);
      me.whatsapp = value;
      input.value = value;
      say(T.saved, true);
    });
    const withAddress = me.orders.find((o) => (o.address || []).filter(Boolean).length);
    return [
      panelHead(T.accountTitle, T.accountLead),
      h('div', { class: 'els-ledger' },
        h('div', { class: 'els-ledger__row' },
          h('p', { class: 'els-ledger__key' }, h('span', { class: 'els-label', text: T.emailLabel })),
          h('div', { class: 'els-ledger__val' }, h('p', null, h('bdi', { dir: 'ltr', text: me.email || '' })))),
        form,
        withAddress ? h('div', { class: 'els-ledger__row' },
          h('p', { class: 'els-ledger__key' }, h('span', { class: 'els-label', text: T.address })),
          h('div', { class: 'els-ledger__val' },
            withAddress.address.filter(Boolean).map((l) => h('p', { dir: 'auto', text: l })),
            h('p', { class: 'els-hint' }, T.addressChange, ' ', h('a', { href: contact().whatsappUrl, target: '_blank', rel: 'noopener', text: T.whatsappUs })))) : null),
      h('div', { class: 'els-out' }, h('button', { type: 'button', class: 'els-btn els-btn--ghost', onclick: logout, text: T.logout }))
    ];
  }

  function viewHelp() {
    const c = contact();
    return [
      panelHead(T.helpTitle, T.helpLead),
      h('div', { class: 'els-contact' },
        h('a', { class: 'els-card-noir', href: c.whatsappUrl, target: '_blank', rel: 'noopener' },
          h('span', { class: 'els-contact__icon', icon: 'wa' }),
          h('span', { style: 'min-width:0' }, h('strong', { text: T.whatsapp }), h('small', { text: T.whatsappText }), h('small', null, h('bdi', { dir: 'ltr', text: c.whatsapp }))),
          h('span', { icon: 'arrow' })),
        h('a', { href: 'mailto:' + c.email },
          h('span', { class: 'els-contact__icon', icon: 'mail' }),
          h('span', { style: 'min-width:0' }, h('strong', { text: T.emailLabel }), h('small', { text: T.mailText }), h('small', null, h('bdi', { dir: 'ltr', text: c.email }))),
          h('span', { icon: 'arrow' }))),
      h('div', { class: 'els-help' },
        h('div', null,
          h('p', { class: 'els-h3', text: T.faqTitle }),
          h('div', { class: 'els-faq' }, T.faq.map(([q, a]) => h('details', null, h('summary', { text: q }), h('p', { text: a }))))),
        h('ul', { class: 'els-links' },
          [[T.shipping, '/policies/shipping-policy'], [T.returns, '/policies/refund-policy'], [T.contactPage, '/pages/contact'], [T.trackPage, '/pages/track']]
            .map(([label, path]) => h('li', null, h('a', { href: link(path) }, h('span', { text: label }), h('span', { icon: 'arrow' }))))))
    ];
  }

  /* ---------- formulaire d'avis ---------- */

  async function shrink(file) {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close?.();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.85));
    if (!blob) throw new Error('photo');
    return new File([blob], (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' });
  }

  function reviewForm({ productId, defaultName, auth, onDone }) {
    const uid = 'r' + Math.random().toString(36).slice(2, 8);
    let rating = 0;
    let hover = 0;
    const photos = [];
    const starLabels = [];
    const paint = () => starLabels.forEach((l, i) => l.classList.toggle('is-on', i < (hover || rating)));
    const stars = h('div', { class: 'els-stars', onmouseleave: () => { hover = 0; paint(); } });
    for (let n = 1; n <= 5; n++) {
      const label = h('label', { class: 'els-star', onmouseenter: () => { hover = n; paint(); } },
        h('input', { type: 'radio', name: uid + '-rating', value: n, class: 'els-sr', onchange: () => { rating = n; paint(); } }),
        h('span', { class: 'els-sr', text: fmt(T.starN, { n }) }));
      label.insertAdjacentHTML('beforeend', ICONS.star);
      starLabels.push(label);
      stars.append(label);
    }
    const title = h('input', { class: 'els-input', id: uid + 't', name: 'title', maxlength: 120, dir: 'auto' });
    const body = h('textarea', { class: 'els-input', id: uid + 'b', name: 'body', rows: 5, minlength: 10, maxlength: 3000, required: true, dir: 'auto' });
    const name = h('input', { class: 'els-input', id: uid + 'n', name: 'name', maxlength: 60, autocomplete: 'given-name', required: true, dir: 'auto' });
    name.value = defaultName || '';
    const file = h('input', { type: 'file', accept: 'image/*', multiple: true, class: 'els-sr' });
    const addLabel = h('label', { class: 'els-photo-add' }, file, h('span', { icon: 'camera' }), h('span', { text: T.addPhoto }));
    const previews = h('div', { class: 'els-photos' }, addLabel);
    const err = h('p', { class: 'els-error', role: 'alert', hidden: true });
    const submit = h('button', { type: 'submit', class: 'els-btn' }, T.rSubmit);
    const showErr = (m) => { err.textContent = m; err.hidden = !m; };

    function drawPhotos() {
      previews.replaceChildren(...photos.map((p, i) => h('span', { class: 'els-photo' },
        h('img', { src: p.url, alt: '' }),
        h('button', { type: 'button', 'aria-label': T.removePhoto, text: '×', onclick: () => { URL.revokeObjectURL(p.url); photos.splice(i, 1); drawPhotos(); } }))));
      if (photos.length < MAX_PHOTOS) previews.append(addLabel);
    }
    file.addEventListener('change', async () => {
      showErr('');
      const files = [...file.files].slice(0, MAX_PHOTOS - photos.length);
      file.value = '';
      submit.disabled = true;
      addLabel.setAttribute('aria-busy', 'true');
      for (const f of files) {
        try {
          const small = await shrink(f);
          photos.push({ file: small, url: URL.createObjectURL(small) });
        } catch {
          showErr(T.ePhotos);
        }
      }
      submit.disabled = false;
      addLabel.removeAttribute('aria-busy');
      drawPhotos();
    });

    const form = h('form', { class: 'els-rform', novalidate: true },
      h('fieldset', null, h('legend', { class: 'els-label', text: T.rating }), stars),
      h('div', null, h('label', { class: 'els-label', for: body.id, text: T.rBody }), body),
      h('div', null, h('label', { class: 'els-label', for: title.id, text: T.rTitle }), title),
      h('div', null, h('label', { class: 'els-label', for: name.id, text: T.rName }), name),
      h('div', null, h('p', { class: 'els-label', text: T.rPhotos }), previews),
      err,
      h('div', null, submit));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      showErr('');
      if (!rating) { showErr(T.eRating); stars.querySelector('input').focus(); return; }
      if (body.value.trim().length < 10) { showErr(T.eBody); body.focus(); return; }
      if (!name.value.trim()) { showErr(T.eName); name.focus(); return; }
      const data = new FormData();
      if (auth.t) data.append('t', auth.t);
      if (auth.order) data.append('order', auth.order);
      data.append('product_id', productId);
      data.append('rating', String(rating));
      data.append('title', title.value.trim());
      data.append('body', body.value.trim());
      data.append('author', name.value.trim());
      data.append('language', lang === 'ar' ? 'ar' : 'en');
      photos.forEach((p) => data.append('photos', p.file));
      submit.disabled = true;
      submit.textContent = T.sending;
      const r = await api('/review', { method: 'POST', form: data, auth: auth.token });
      submit.disabled = false;
      submit.textContent = T.rSubmit;
      if (!r.ok) {
        const code = r.data.error;
        if (code === 'duplicate') { onDone?.(true); return form.replaceWith(thanks(T.eDuplicate)); }
        if (r.status === 401 || code === 'expired') return showErr(T.rvExpired);
        return showErr(code === 'rating' || (code === 'invalid' && r.data.field === 'rating') ? T.eRating
          : code === 'body' || (code === 'invalid' && r.data.field === 'body') ? T.eBody
          : code === 'photos' ? T.ePhotos
          : code === 'rate' || r.status === 429 ? T.eRate
          : r.status === 0 ? T.eNetwork : T.eServer);
      }
      photos.forEach((p) => URL.revokeObjectURL(p.url));
      const t = thanks();
      form.replaceWith(t);
      t.focus();
      onDone?.(false, t);
    });
    return form;
  }

  function thanks(text) {
    return h('div', { class: 'els-thanks', tabindex: '-1', role: 'status' },
      h('div', { class: 'els-thanks__mark', icon: 'check' }),
      h('p', { class: 'els-callout__title', text: T.thanksTitle }),
      h('p', { class: 'els-muted', text: text || T.thanksText }));
  }

  /* ---------- avis par lien (?review=JETON) ---------- */

  async function reviewLink(t) {
    setState('review');
    reviewBox.replaceChildren(h('div', { class: 'els-skel', style: 'display:block' },
      h('div', { class: 'els-skel__line els-skel__line--xs' }), h('div', { class: 'els-skel__line els-skel__line--lg' }), h('div', { class: 'els-skel__media', style: 'height:320px' })));
    const r = await api('/review', { query: { t } });
    const spaceUrl = location.pathname + (mock ? '?mock=' + [...mock].join(',') : '');
    if (!r.ok || !r.data || !Array.isArray(r.data.items)) {
      reviewBox.replaceChildren(
        h('p', { class: 'els-eyebrow', text: T.rvEyebrow }),
        h('h1', { class: 'els-title', text: T.rvTitle }),
        h('div', { class: 'els-review-card' },
          h('p', { role: 'alert', style: 'margin:0 0 18px', text: r.status === 0 ? T.eNetwork : T.rvExpired }),
          h('a', { class: 'els-btn', href: spaceUrl }, T.goSpace)));
      return;
    }
    const d = r.data;
    const items = d.items.filter((i) => i.productId);
    const orderName = (d.order && d.order.name) || '';
    const lead = h('p', { class: 'els-lead' }, ...splitBold(d.firstName ? T.rvLead : T.rvLeadPlain, { name: d.firstName || '', order: orderName }));
    const card = h('div', { class: 'els-review-card' });
    reviewBox.replaceChildren(
      h('p', { class: 'els-eyebrow', text: T.rvEyebrow }),
      h('h1', { class: 'els-title', text: T.rvTitle }),
      lead,
      card,
      h('p', { style: 'margin-top:24px' }, h('a', { class: 'els-link', href: spaceUrl }, T.goSpace)));

    let currentId = (items.find((i) => !i.reviewed) || {}).productId;
    function draw(afterDone) {
      const left = items.filter((i) => !i.reviewed);
      card.replaceChildren();
      if (!left.length && !afterDone) {
        card.append(thanks(T.rvAllDone));
        return;
      }
      if (afterDone) {
        card.append(afterDone);
        if (left.length) {
          currentId = left[0].productId;
          card.append(h('div', { style: 'text-align:center;margin-top:18px' }, h('button', { type: 'button', class: 'els-btn els-btn--ghost', onclick: () => draw() }, T.nextItem)));
        }
        afterDone.focus();
        return;
      }
      if (items.length > 1) {
        card.append(h('p', { class: 'els-label', text: T.chooseItem }), h('ul', { class: 'els-chooser' }, items.map((it) => h('li', null,
          h('button', {
            type: 'button', 'aria-pressed': String(String(it.productId) === String(currentId)), disabled: !!it.reviewed,
            onclick: () => { currentId = it.productId; draw(); }
          },
          safeUrl(it.image) ? h('img', { src: safeUrl(it.image), alt: '', width: 44, height: 44 }) : null,
          h('span', null, it.title || '', it.reviewed ? h('small', { style: 'display:block;color:var(--els-ok)', text: T.reviewed }) : null))))));
      } else if (items[0]) {
        const it = items[0];
        card.append(h('div', { class: 'els-ritem__row', style: 'padding:0 0 18px' },
          safeUrl(it.image) ? h('img', { src: safeUrl(it.image), alt: '', width: 64, height: 64 }) : h('span'),
          h('p', { class: 'els-ritem__title', text: it.title || '' }), h('span')));
      }
      card.append(reviewForm({
        productId: currentId,
        defaultName: d.firstName,
        auth: { t },
        onDone: (dup, node) => {
          const it = items.find((i) => String(i.productId) === String(currentId));
          if (it) it.reviewed = true;
          if (!dup && node) draw(node);
        }
      }));
    }
    draw();
  }

  /* ---------- démarrage ---------- */

  const reviewToken = params.get('review');
  if (reviewToken) reviewLink(reviewToken);
  else if (token) loadMe();
  else showLogin();

  /* ---------- données fictives (?mock=…) ---------- */

  async function mockApi(path, method, json, form, auth, query) {
    await new Promise((r) => setTimeout(r, 450));
    const ok = (data) => ({ ok: true, status: 200, data });
    const fail = (status, data) => ({ ok: false, status, data });
    if (path === '/login') return ok({ ok: true });
    if (path === '/verify') {
      if (json.code === '000000') return fail(400, { error: 'expired' });
      return json.code === '123456' ? ok({ token: 'mock-token', email: json.email }) : fail(400, { error: 'mismatch' });
    }
    if (path === '/me') return auth ? ok(mockMe()) : fail(401, { error: 'auth' });
    if (path === '/phone') return ok({ ok: true });
    if (path === '/review' && method === 'GET') {
      if (query.t === 'bad') return fail(404, { error: 'expired' });
      return ok({ firstName: 'Noura', order: { name: '#1198' }, items: [
        { productId: '10326012100696', title: 'The Amira Vanity — Black', image: IMG.vanityBlack, reviewed: false },
        { productId: '10326012297304', title: 'The Amira Pouch — Butter', image: IMG.pouchButter, reviewed: false },
        { productId: '10326012035160', title: 'The Amira Pouch — Black', image: IMG.pouchBlack, reviewed: true }
      ] });
    }
    if (path === '/review' && method === 'POST') {
      if (form.get('body') === 'duplicate review') return fail(409, { error: 'duplicate' });
      return ok({ ok: true });
    }
    return fail(404, {});
  }

  function mockMe() {
    const day = 864e5;
    const iso = (n) => new Date(Date.now() + n * day).toISOString();
    const ymd = (n) => iso(n).slice(0, 10);
    const has = (k) => mock.has(k);
    const stage = has('delivered') ? 'delivered' : has('prepared') ? 'prepared' : has('out') ? 'out' : 'shipped';
    const idx = STAGES.indexOf(stage);
    const current = {
      number: 1243, name: '#1243', createdAt: iso(-3), total: '1340.00', currency: 'AED', stage, stageIndex: idx,
      deliveredAt: stage === 'delivered' ? iso(-1) : null,
      eta: stage === 'delivered' ? null : { from: ymd(2), to: ymd(4) }, late: has('late'),
      tracking: idx >= 2 ? { code: 'ELR 4821 7730', url: link('/pages/track?code=48217730') } : null,
      carrier: idx >= 2 ? { status: 'in_transit', lastEvent: 'Arrived at the Dubai sorting centre', lastAt: iso(-0.3) } : null,
      canReturn: stage === 'delivered', reviewable: stage === 'delivered',
      items: [
        { title: 'The Amira Vanity — Himalaya', variant: 'Default Title', quantity: 1, image: IMG.vanityHimalaya, href: link('/products/amira-vanity-himalaya'), productId: '10326012199000' },
        { title: 'The Amira Pouch — Butter', variant: 'Default Title', quantity: 2, image: IMG.pouchButter, href: link('/products/amira-pouch-butter'), productId: '10326012297304' }
      ],
      address: ['Noura Al Mansouri', 'Villa 12, Street 4', 'Al Barsha 2', 'Dubai', 'United Arab Emirates'],
      reorderUrl: link('/cart/10326012199000:1'), shortAddress: { missing: has('address'), url: 'https://dashboard.elirati.com/adresse?o=1243' }
    };
    const orders = has('empty') ? [] : [
      current,
      { number: 1198, name: '#1198', createdAt: iso(-12), total: '890.00', currency: 'AED', stage: 'delivered', stageIndex: 4, deliveredAt: iso(-6), eta: null, late: false,
        tracking: { code: 'ELR 3310 0947', url: link('/pages/track?code=33100947') }, carrier: { status: 'delivered', lastEvent: 'Delivered to the customer', lastAt: iso(-6) },
        canReturn: true, reviewable: true,
        items: [{ title: 'The Amira Vanity — Black', variant: 'Default Title', quantity: 1, image: IMG.vanityBlack, href: link('/products/amira-vanity-black'), productId: '10326012100696' }],
        address: ['Noura Al Mansouri', 'Villa 12, Street 4', 'Al Barsha 2', 'Dubai', 'United Arab Emirates'], reorderUrl: link('/products/amira-vanity-black'), shortAddress: { missing: false, url: null } },
      { number: 1102, name: '#1102', createdAt: iso(-40), total: '398.00', currency: 'AED', stage: 'cancelled', stageIndex: -1, deliveredAt: null, eta: null, late: false,
        tracking: null, carrier: null, canReturn: false, reviewable: false,
        items: [{ title: 'The Amira Pouch — Black', variant: 'Default Title', quantity: 1, image: IMG.pouchBlack, href: link('/products/amira-pouch-black'), productId: '10326012035160' }],
        address: [], reorderUrl: link('/products/amira-pouch-black'), shortAddress: { missing: false, url: null } }
    ];
    return {
      email: 'noura@example.com', firstName: 'Noura', whatsapp: '+971501234567',
      promo: has('nopromo') ? null : { code: 'NOURA15', percent: 15, url: link('/discount/NOURA15') },
      contact: { whatsapp: '+971 58 510 1654', whatsappUrl: 'https://wa.me/971585101654', email: 'contact@elirati.com' },
      orders, offer: null
    };
  }
}

const IMG = {
  vanityBlack: 'https://cdn.shopify.com/s/files/1/0739/6730/4792/files/amira-vanity-black-studio.png?v=1790634548&width=300',
  vanityHimalaya: 'https://cdn.shopify.com/s/files/1/0739/6730/4792/files/amira-vanity-himalaya-studio.png?v=1790808371&width=300',
  pouchButter: 'https://cdn.shopify.com/s/files/1/0739/6730/4792/files/amira-pouch-butter-pouch_bb382dc4-3b72-42d4-9772-6695c2dd2ad3.png?v=1790630426&width=300',
  pouchBlack: 'https://cdn.shopify.com/s/files/1/0739/6730/4792/files/MA2tzKEvxFxZcJGHyQb03_studio-45.png?v=1792744746&width=300'
};

const store = {
  key() { return new URLSearchParams(location.search).has('mock') ? 'el_space_token_mock' : 'el_space_token'; },
  get() { try { return localStorage.getItem(this.key()); } catch { return null; } },
  set(v) { try { localStorage.setItem(this.key(), v); } catch {} },
  del() { try { localStorage.removeItem(this.key()); } catch {} }
};

const root = document.querySelector('[data-el-space]');
if (root && !root.dataset.ready) {
  root.dataset.ready = '1';
  start();
}
